import NumberInput from './NumberInput';

class ActRecordNumberInput extends NumberInput {
  transform = value => value.substr(0, 11);
}

export default ActRecordNumberInput;
